import { AutogenModelDistanceVersion, AutogenRowDistanceVersion } from "./autogen/AutogenModelDistanceVersion";

export class ModelDistanceVersion extends AutogenModelDistanceVersion<RowDistanceVersion> {
	constructor() {
		super(RowDistanceVersion);
	}
}

export class RowDistanceVersion extends AutogenRowDistanceVersion {
}